
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import {
  required,
  minLength
} from "vuelidate/lib/validators";
import errorParseNetwork from "~/helpers/errorParseNetwork";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";

export default BaseCmsBlock.extend({
  name: "FreightCalculatorBlock",

  data: function () {
    return {
      form: {
        cityFrom: "",
        cityTo: "",

        width: "",
        height: "",
        length: "",
        weight: "",

        name: "",
        phone: "",
        shippingName: "",

        note: ""
      }
    }
  },

  validations: function () {
    const form = {
      cityFrom: {
        required,
      },
      cityTo: {
        required,
      },

      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(18)
      },
    };

    return {
      form,
    };
  },

  computed: {
    localValues: function () {
      return this.externalData?.FreightCalculatorBlock || this.values || {}
    },

    title: function () {
      return this.values.title || this.localValues?.title || this.externalData?.CalculatorBlock?.title
    },
    customBlueTitle: function () {
      return this.externalData?.CalculatorBlock?.customBlueTitle || false
    },

    errorCityFrom: function () {
      const error = this.$v?.form?.cityFrom;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Выберите город"
      }

      return null
    },
    errorCityTo: function () {
      const error = this.$v?.form?.cityTo;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Выберите город"
      }

      return null
    },
    errorName: function () {
      const error = this.$v?.form?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },

    cargoName: function () {
      return this.localValues?.cargoName || ""
    },

    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },
  },

  components: {
    InputDropDown: () => import("./components/CalculatorBlock/InputDropDown"),
    FormSlider: () => import("~/components/form/FormSlider.vue")
  },

  watch: {
    cargoName: function () {
      this.initForm();
    },
  },

  mounted: function () {
    this.initForm();
  },

  methods: {
    initForm: function () {
      this.form.shippingName = this.localValues?.cargoName || "";
    },
    changeForm: function (name, value) {
      let form = {...this.form}
      form[name] = value;
      this.form = form;
    },

    submitForm: async function (codeRecaptcha = '') {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      let body = {
        type: "Получить расчет перевозки",
        name: this.form.name,
        phone: (this.form?.phone || "").replace(/[^\d]/g, ''),
        url: window.location.href,
        source: this.$cookies.get('sbjs_current') || '',
        additional_data: {}
      }
      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });
      const utmLabels = parseUtmLabels();
      if (!!utmLabels) {
        body.additional_data = {
          ...body.additional_data,
          ...utmLabels
        }
      }

      let message = [];
      if (this.form?.cityFrom) {
        message.push(`Город отправления: ${this.form?.cityFrom}`);
      }
      if (this.form?.cityTo) {
        message.push(`Город прибытия: ${this.form?.cityTo}`);
      }
      if (this.form.shippingName) {
        message.push(`Наименование груза: ${this.form.shippingName}`);
      }
      if (this.form.width) {
        message.push(`Ширина (м): ${this.form.width}`);
      }
      if (this.form.height) {
        message.push(`Высота (м): ${this.form.height}`);
      }
      if (this.form.length) {
        message.push(`Длина (м): ${this.form.length}`);
      }
      if (this.form.weight) {
        message.push(`Масса груза (т): ${this.form.weight}`);
      }
      if (this.form.note) {
        message.push(`Особенности: ${this.form.note}`);
      }
      message = message.join("<br/>");
      if (!!message) {
        body.message = message;
      }
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });
      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");
      this.clearForm();

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$yandexMetrika.reachGoal("get_calculation_application");
      this.$yaglaaction('get_calculation_application');
    },
    clearForm: function () {
      this.form = {
        cityFrom: "",
        cityTo: "",

        width: "",
        height: "",
        length: "",
        weight: "",

        name: "",
        phone: "",
        shippingName: "",

        note: ""
      };
      this.$v.$reset();
    }
  }
})
